import {
  Box,
  Typography,
  Grid2,
  Stack,
  Button
} from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { useGetBranchByIdQuery } from "../../../api/branchApi";
import { useGetUsersByBranchIdQuery } from "../../../api/userApi";
import { EmployeeListView } from "./employeeListView";
import { LoadingIndicator } from "../../shared/alerts/loadingIndicator";
import { FC } from "react";
import { useAuthenticatedUser } from "../../../hooks/useAuthenticatedUser";
import { Add } from "@mui/icons-material";
import { Collection } from "../../../enums/collections.enum";

export const EmployeeListByBranchContainer: FC<{ showAddEmployee?: boolean; branchId?: string; companyId?: string }> = ({ showAddEmployee, branchId: branchIdProp, companyId: companyIdProp }) => {
  const { branchId: branchIdParam, companyId: companyIdParam } = useParams<{ branchId?: string, companyId?: string }>();
  const branchId = branchIdProp ?? branchIdParam;
  const companyId = companyIdProp ?? companyIdParam;

  const { currentUserIsOwnerOf } = useAuthenticatedUser();

  const {
    data: users = [],
    isLoading: loading,
    error: rawError,
  } = useGetUsersByBranchIdQuery({ branchId }, {
    skip: !branchId,
  });

  const { data: branch } = useGetBranchByIdQuery(branchId ?? "");

  if (loading) {
    return <LoadingIndicator message="Loading employee data..." />
  }

  if (rawError) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
        <Typography color="error">Error: {String(rawError)}</Typography>
      </Box>
    );
  }

  if (!branch) {
    return <>No Branch data</>
  }
  return (
    <Grid2>
      {currentUserIsOwnerOf(companyId) && showAddEmployee && <Stack direction="row" justifyContent="space-between" alignItems="center" mr={2}>
        <Typography variant="h5" fontWeight={600}>

        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          component={Link}
          to={`${Collection.Users}/add`}
        >
          Add Employee
        </Button>
      </Stack>}

      <EmployeeListView
        users={users}
        branch={branch}
      />
    </Grid2>
  );
};

